import React, { useState, useRef, useEffect } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";

export default function CustomSelect({ admin, statusOptions, handleSelectChange }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentStatus = admin?.subadmins?.subAdminStatus;
  const statusConfig = statusOptions[currentStatus] || {
    options: [],
    color: "#f5f5f5",
    textColor: "#000",
    placeholder: "Select",
  };

  const handleOptionClick = (option) => {
    setOpen(false);
    handleSelectChange(option, admin);
  };

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      {/* Container with two parts */}
      <div style={{ display: "flex", border: "1px solid #E1E1E1", borderRadius: "4px", overflow: "hidden", backgroundColor: statusConfig.color }}>
        {/* Left: Status */}
        <div
          style={{
            // backgroundColor: statusConfig.color,
            color: statusConfig.textColor,
            fontWeight: "600",
            fontFamily: "Roboto",
            padding: "4px",
            fontSize: "12px",
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "8px",
            width: "6.2rem",
            height: "14px",
            opacity: "1",
          }}
        >
          {statusConfig.placeholder}
        </div>

        {/* Right: Arrow */}
        <div
          onClick={() => setOpen(!open)}
          style={{
            backgroundColor: "#fff",
            padding: "4px 0px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #ddd",
          }}
        >
          {/* <span style={{ fontSize: "12px" }}>{open ? "<MdKeyboardArrowUp/>" : "<MdKeyboardArrowDown/>"}</span> */}
          <span style={{ fontSize: "12px" }}>
            {open ? <MdKeyboardArrowUp style={{fontSize: "20px"}}/> : <MdKeyboardArrowDown  style={{fontSize: "20px"}}/>}
          </span>
        </div>
      </div>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "90%",
            left: 0,
            width: "128px",
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "4px",
            marginTop: "4px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          {statusConfig.options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option)}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                fontSize: "13px",
                textAlign: "left",
                color: "#242533",
                fontFamily: "Roboto",
                fontWeight: "400"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
